"use client";

import { useSnackbarHandler } from "@repo/lib/hooks/common";
import { MAX_CART_ITEM_QTY } from "@repo/constants/cart";
import cx from "classnames";
import { useTranslations } from "next-intl";
import { useCallback } from "react";
function QtyButton({
  type,
  onClick,
  disabled
}) {
  return <button type="button" onClick={onClick} aria-label={type === "plus" ? "Increase item quantity" : "Reduce item quantity"} disabled={disabled} className={cx("ease border-miniCart-cartItems-quantityButtonBorder text-miniCart-cartItems-quanttityButtonIcon bg-miniCart-cartItems-quantityButtonBg h-9 min-w-[42px] max-w-[42px] border-x text-2xl transition-all duration-200 hover:bg-[#FFFDFB] md:h-11")} data-sentry-component="QtyButton" data-sentry-source-file="QuantitySelector.jsx">
      {type === "plus" ? <span>+</span> : <span>-</span>}
    </button>;
}
const QuantitySelector = ({
  qty,
  setQty,
  type
}) => {
  const {
    showSnackbar
  } = useSnackbarHandler();
  const t = useTranslations("Common");
  const handleClick = useCallback(() => {
    if (type === "plus") {
      // Increment, ensuring qty does not exceed MAX_CART_ITEM_QTY
      if (qty < MAX_CART_ITEM_QTY) {
        setQty(prevQty => prevQty + 1);
      } else {
        showSnackbar({
          type: "error",
          message: t("Maximum_Quantity_Is_Exceeded")
        });
      }
    } else if (type === "minus" && qty > 1) {
      setQty(prevQty => prevQty - 1); // Decrement, ensuring qty does not go below 1
    }
  }, [qty, type, setQty, showSnackbar, t]);
  const isDisabled = type === "minus" && qty <= 1;
  return <QtyButton type={type} onClick={handleClick} disabled={isDisabled} data-sentry-element="QtyButton" data-sentry-component="QuantitySelector" data-sentry-source-file="QuantitySelector.jsx" />;
};
export default QuantitySelector;